import { Component, OnInit, OnDestroy } from '@angular/core';
import { SidenavService } from '../../services/sidenav.service';
import { DatePipe, NgIf, NgFor } from '@angular/common';
import { TranslationService } from '../../../common/services/languages/translation.service';
import { OrchestrationService } from '../../services/orchestration-service/orchestration.service';
import { ApiResponseActions } from '../../../store/api-response/api-response-actions';
import { select, NgRedux } from '@angular-redux/store';
import { Observable } from 'rxjs';
import { skip } from 'rxjs/operators';
import { ApiResponseState } from '../../../store/api-response/api-response-state.model';
import { AppState } from '../../../store/state.model';
import { MatDialog } from '@angular/material';
import { SubFeaturesComponent } from '../../../common/components/sub-features/sub-features.component';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatSelect, MatOption, MatLabel } from '@angular/material/select';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-phone-capability',
    templateUrl: './phone-capability.component.html',
    styleUrls: ['./phone-capability.component.scss'],
    imports: [FormsModule, NgIf, MatFormField, MatSelect, NgFor, MatOption, MatLabel, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatButton, TranslatePipe]
})
export class PhoneCapabilityComponent implements OnInit, OnDestroy {

  /**
   * @property used to store the manufacturers list
   */
  public manufacturersList: Array<any>;
  /**
   * @property used to store the phone list
   */
  public phoneList: Array<any>;
  /**
   * @property to store the api subscription
   */
  private apiSubscription;
  /**
  * @Property to observe the redux customer store
  **/
  @select('api') readonly apiObservable: Observable<ApiResponseState>;

  /**
   * @property huconfigId used to store the head unit configId
   */
  public huConfigId: number;

  /**
   * @property isSelected used to store the flag to enable the phone selection.
   */
  public isSelected: boolean;
  /**
   * @property displayedColumns used to store the columns for the features table.
   */
  public displayedColumns: string[];
    /**
   * @property dataSource used to store the data for the features table.
   */
  public dataSource: Array<any>;
  /**
   * @property isCapable to true if vehicles phone config and capabilities exist.
   */
  public isCapable: boolean;
  constructor(
    private sidenav: SidenavService,
    public datepipe: DatePipe,
    private translate: TranslationService,
    private orch: OrchestrationService,
    public ngRedux: NgRedux<AppState>,
    public dialog: MatDialog,
  ) {
    this.defaults();
  }

  /*
   * @function ngOnInit sets initial configuration
   */
  ngOnInit() {
    this.apiSubscription = this.apiObservable.pipe(skip(1)).subscribe((api) => {
      if (api.apiAction === ApiResponseActions.SET_PHONE_CONFIG && api.phoneConfigResponse['type'] === 'success') {
        this.isCapable = true;
        this.setPhoneConfigSuccess(api);
      } else if (api.apiAction === ApiResponseActions.SET_PHONE_CONFIG && api.phoneConfigResponse['type'] === 'error') {
        this.isCapable = false;
      }
      if (api.apiAction === ApiResponseActions.SET_PHONE_COMPATIBILITIES && api.phoneCompatibilitiesResponse['type'] === 'success') {
        this.setPhoneCompatailitiesSuccess(api);
        this.isCapable = true;
      } else if (api.apiAction === ApiResponseActions.SET_PHONE_COMPATIBILITIES && api.phoneCompatibilitiesResponse['type'] === 'error') {
        this.isCapable = false;
      }
    });
  }
  /**
   * @function setPhoneConfigSuccess  sets the manufacturers list upon phone config success response.
   * @arg api of type object
   */
  public setPhoneConfigSuccess (api: object): void {
    const payload = api['phoneConfigResponse']['payload']['phoneModelResponse']['huPhoneManufacture']['0'];
    this.huConfigId = payload['headUnitConfig'] || payload['HeadUnitConfig'];
    payload['manufacturers'].forEach((manufacturer) => {
      const manufacturerObj = manufacturer['manufacturer'];
      this.manufacturersList.push(manufacturerObj);
    });
  }
  /**
   * @function setPhoneCompatailitiesSuccess sets the Phone Compatailities columns and table data source upon Phone Compatailities Success response.
   * @arg api of type object
   */
  public setPhoneCompatailitiesSuccess(api: object): void {
    const compatibilities = api['phoneCompatibilitiesResponse']['payload']['getFeatureCompatibiltyResponse']['featureCompatibiltyResponse'];
    this.displayedColumns = ['featureGroupName', 'compatibilty', 'subFeature'];
    this.dataSource = compatibilities;
  }
  /**
   * @function defaults resets the phone and manufacturers list
   */
  defaults() {
    this.phoneList = [];
    this.manufacturersList = [];
    this.dataSource = [];
    this.isSelected = false;
    this.isCapable = true;
  }

  /**
  * @function close closes the side nav when called and resets the lists
  **/
  public close(): void {
    this.sidenav.close();
    this.defaults();
  }

  /**
   * @function changeManufacturer triggered when the Manufacturer group is changed
   * @arg manufacturer of type object
   */
  public changeManufacturer(manufacturer: object): void {
    this.phoneList = manufacturer['phones'];
    this.isSelected = true;
    this.dataSource = [];
  }

  /**
   * @function changePhone triggered when the phone is changed
   * @arg phone of type object
   */
  public changePhone(phone: object): void {
    const phoneConfigId = phone['phoneConfigId'] || phone['PhoneConfigId'];
    this.orch.getPhoneCompatibilities({ huConfigId: this.huConfigId, phoneConfigId: phoneConfigId });
  }

  /**
   * @function ngOnDestroy Runs final sequence
   */
  ngOnDestroy() {
    this.apiSubscription.unsubscribe();
  }

  /**
   * @function isDataLoaded returns false if dataSource lenght is false
   */
  public isDataLoaded(): boolean {
    return !(this.dataSource.length === 0);
  }

  /**
  * @method showSubFeatures displays the sub features
  * @arg feature records contains list of records
  */
 public showSubFeatures(feature: object): void {
  this.dialog.open(SubFeaturesComponent, {
    data: feature,
    width: '39em',
    height: '40em'
  });
}
}
